export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'slot',
      name: 'currency',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Total deposit',
    },
    cell: {
      type: 'slot',
      name: 'totalDeposit',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Deposit fee',
    },
    cell: {
      type: 'slot',
      name: 'depositFee',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Total withdrawal',
    },
    cell: {
      type: 'slot',
      name: 'totalWithdrawal',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Withdrawal fee',
    },
    cell: {
      type: 'slot',
      name: 'withdrawalFee',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Blockchain fee',
    },
    cell: {
      type: 'slot',
      name: 'blockchainFee',
    },
  },
];
